import { EnvironmentProviders, Provider } from '@angular/core';

/**
 * Developer-only providers — deliberately EMPTY here, so no build ships them.
 *
 * The `development` build configuration (what `ng serve` uses) swaps this file for
 * dev-tools.providers.development.ts via `fileReplacements` in angular.json. Every other
 * configuration — production and all the legacy per-tenant ones — compiles this empty version,
 * so the dev tooling isn't merely inactive there, it isn't in the bundle at all.
 *
 * That includes `ng serve -c <tenant>`: serving a tenant configuration locally gets no devtools.
 *
 * Keep both files' exports and types identical — production builds never compile the
 * development version, so a mismatch would only surface under `ng serve`.
 */
export const DEV_TOOLS_PROVIDERS: (Provider | EnvironmentProviders)[] = [];
